import React from "react";

import { ElementState, Preview } from "@creatomate/preview";

import { NumberField } from "@culturehq/components";
import { Trans } from "app/utils";

interface BorderRadiusProps {
  activeElement: ElementState;
  preview: Preview;
}

const BorderRadius: React.FC<BorderRadiusProps> = ({
  activeElement,
  preview
}) => {
  const handleBorderRadiusChange = async (value: string) => {
    const borderRadius = Math.max(+value, 0);
    await preview.applyModifications({
      [`${activeElement.source.id}.border_radius`]: borderRadius
    });
  };

  return (
    <NumberField
      className="chq-ffd-border"
      name="border-radius"
      min={0}
      value={activeElement.source.border_radius || "0"}
      onChange={handleBorderRadiusChange}
    >
      <Trans>Border Radius</Trans>
    </NumberField>
  );
};

export default BorderRadius;
